import React from 'react';
import { bannerContent } from '@consts/photobookConsts';
import { useProducts } from '@hooks';

import { DesktopBanner, MobileBanner } from '@components/Blocks/Banners';
import { FilterProductsBlock } from '@components/Blocks/FilterProductsBlock/FilterProductsBlock';
import { useProductFilters } from '@hooks/useProductFiltersAndCategories';
import { MiniServices } from '@components/ProductsPage/MiniServices';
import { ThinPromo } from '@components/ProductsPage/ThinPromo';
import Layout from '@components/Layouts/Layout';
import SEO from '@components/Layouts/SEO';
import { YandexTableau } from '@components/Layouts/YandexTableau';
import { ProductsContainer } from '@components/ProductsPage/ProductsContainer';
import { PopularProducts } from '@components/Blocks/PopularProducts';

import styles from './photobooks.module.scss';

export function Head() {
  return (
    <>
      <SEO
        title="Фотокниги на заказ с доставкой: сделать фотокнигу онлайн"
        description="Для самых важных моментов и событий"
      />
      <YandexTableau />
    </>
  );
}

function PhotobooksPage() {
  const { photobooks } = useProducts();
  const {
    filteredProducts,
    selectedFilters,
    hasActiveFilters,
    handleSelect,
    handleRemove,
    pageOptions,
  } = useProductFilters();

  const products = photobooks.filter((p) => p.productType !== 'wedding');

  return (
    <Layout>
      <ProductsContainer>
        <div className={styles.bannerBlock}>
          <DesktopBanner customContent={bannerContent} />
          <MobileBanner customContent={bannerContent} />
        </div>
        <FilterProductsBlock
          products={products}
          filteredProducts={filteredProducts}
          selectedFilters={selectedFilters}
          handleSelect={handleSelect}
          handleRemove={handleRemove}
          pageOptions={pageOptions}
        />
        {hasActiveFilters && filteredProducts.length === 0 ? (
          <PopularProducts items={photobooks.slice(0, 4)} />
        ) : null}
        <ThinPromo
          title="Скидки при заказе нескольких фотокниг:"
          text={
            <>
              5% при покупке 2&nbsp;фотокниг по&nbsp;промокоду <b>ФОТОКНИГИ5</b> <br /> 7% при
              покупке от 3&nbsp;фотокниг по&nbsp;промокоду <b>ФОТОКНИГИ7</b>
            </>
          }
        />
        <MiniServices header="Услуги" />
      </ProductsContainer>
    </Layout>
  );
}
export default PhotobooksPage;
